// import React, { useState } from "react";
// import CryptoJS from "crypto-js";

// const CodePaginator = () => {
//   const [codeBlocks, setCodeBlocks] = useState([]);
//   const [completedIndexes, setCompletedIndexes] = useState([]);
//   const [pendingIndexes, setPendingIndexes] = useState([]);
//   const [copiedIndex, setCopiedIndex] = useState(null);

//   const secretKey = "myStrongSecretKey123";

//   const extractNameAndStation = (block) => {
//     const nameMatch = block.match(/nameSetter\.call\([^,]+,\s*"([^"]+)"\)/);
//     const stationMatch = block.match(
//       /streetSetter\.call\([^,]+,\s*"([^"]+)"\)/
//     );
//     return {
//       name: nameMatch ? nameMatch[1].trim() : "Unknown",
//       station: stationMatch ? stationMatch[1].trim() : "Unknown",
//     };
//   };

//   const handleFileUpload = (e) => {
//     const file = e.target.files[0];
//     if (!file) return;

//     const reader = new FileReader();
//     reader.onload = (event) => {
//       try {
//         const encryptedContent = event.target.result;
//         const bytes = CryptoJS.AES.decrypt(encryptedContent, secretKey);
//         const decryptedText = bytes.toString(CryptoJS.enc.Utf8);

//         if (!decryptedText) {
//           alert("❌ Decryption failed. Check your secret key.");
//           return;
//         }

//         const blocks = decryptedText
//           .split(/setTimeout\(\s*\(\)\s*=>\s*{/g)
//           .filter(Boolean)
//           .map((block) => `setTimeout(() => {${block.trim()}`);
//         setCodeBlocks(blocks);
//         setCompletedIndexes([]);
//         setPendingIndexes([]);
//         setCopiedIndex(null);
//       } catch (err) {
//         alert("❌ Error reading or decrypting file.");
//         console.error(err);
//       }
//     };

//     reader.readAsText(file);
//   };

//   const handleCopy = (index) => {
//     navigator.clipboard.writeText(codeBlocks[index]).then(() => {
//       setCopiedIndex(index);
//       setTimeout(() => setCopiedIndex(null), 2000); // highlight for 2 seconds
//       alert(`✅ Code for member ${index + 1} copied!`);
//     });
//   };

//   const handleComplete = (index) => {
//     setCompletedIndexes((prev) => [...prev, index]);
//     setPendingIndexes((prev) => prev.filter((i) => i !== index));
//   };

//   const handlePending = (index) => {
//     if (!pendingIndexes.includes(index)) {
//       setPendingIndexes((prev) => [...prev, index]);
//     }
//   };

//   const getRows = () => {
//     const active = [];
//     const pending = [];
//     const completed = [];

//     codeBlocks.forEach((block, index) => {
//       const data = {
//         serial: index + 1,
//         index,
//         block,
//         ...extractNameAndStation(block),
//       };

//       if (completedIndexes.includes(index)) {
//         completed.push(data);
//       } else if (pendingIndexes.includes(index)) {
//         pending.push(data);
//       } else {
//         active.push(data);
//       }
//     });

//     return { active, pending, completed };
//   };

//   const { active, pending, completed } = getRows();

//   return (
//     <div className="container mt-4">
//       <div className="text-center mb-3">
//         <h3>Upload Encrypted Text File</h3>
//         <input type="file" accept=".txt" onChange={handleFileUpload} />
//       </div>

//       {codeBlocks.length > 0 && (
//         <div>
//           <h5>Total Members: {codeBlocks.length}</h5>

//           <table className="table table-bordered mt-3">
//             <thead className="table-light">
//               <tr>
//                 <th>S.No</th>
//                 <th>Name</th>
//                 <th>Station</th>
//                 <th>Copy</th>
//                 <th>Status</th>
//               </tr>
//             </thead>
//             <tbody>
//               {[...active, ...pending, ...completed].map((row) => {
//                 const isCompleted = completedIndexes.includes(row.index);
//                 const isPending = pendingIndexes.includes(row.index);
//                 const isCopied = copiedIndex === row.index;

//                 return (
//                   <tr
//                     key={row.index}
//                     style={{
//                       backgroundColor: isCopied ? "#d1e7dd" : undefined,
//                       color: isPending && !isCompleted ? "red" : undefined,
//                       opacity: isCompleted ? 0.5 : 1,
//                       textDecoration: isCompleted ? "line-through" : "none",
//                     }}
//                   >
//                     <td>{row.serial}</td>
//                     <td>{row.name}</td>
//                     <td>{row.station}</td>
//                     <td>
//                       <button
//                         className="btn btn-sm btn-success"
//                         onClick={() => handleCopy(row.index)}
//                         disabled={isCompleted}
//                       >
//                         📋 Copy
//                       </button>
//                     </td>
//                     <td>
//                       {!isCompleted && (
//                         <>
//                           <button
//                             className="btn btn-sm btn-warning me-2"
//                             onClick={() => handleComplete(row.index)}
//                           >
//                             ✅ Complete
//                           </button>
//                           <button
//                             className="btn btn-sm btn-danger"
//                             onClick={() => handlePending(row.index)}
//                           >
//                             ⏳ Pending
//                           </button>
//                         </>
//                       )}
//                       {isCompleted && (
//                         <button className="btn btn-sm btn-secondary" disabled>
//                           ✅ Completed
//                         </button>
//                       )}
//                     </td>
//                   </tr>
//                 );
//               })}
//             </tbody>
//           </table>
//         </div>
//       )}
//     </div>
//   );
// };

// export default CodePaginator;


import React, { useState } from "react";
import CryptoJS from "crypto-js";
import "bootstrap/dist/css/bootstrap.min.css";

const CodePaginator = () => {
  const [codeBlocks, setCodeBlocks] = useState([]);
  const [completedIndexes, setCompletedIndexes] = useState([]);
  const [pendingIndexes, setPendingIndexes] = useState([]);
  const [copiedIndex, setCopiedIndex] = useState(null);
  const [selectedMember, setSelectedMember] = useState(null); // For modal
  const [showModal, setShowModal] = useState(false); // Modal visibility

  const secretKey = "myStrongSecretKey123";

  const extractMemberDetails = (block) => {
    const getMatch = (pattern) => {
      const match = block.match(pattern);
      return match ? match[1].trim() : "Unknown";
    };

    return {
      name: getMatch(/nameSetter\.call\([^,]+,\s*"([^"]+)"\)/),
      surname: getMatch(/surNameSetter\.call\([^,]+,\s*"([^"]+)"\)/),
      fatherSpouce: getMatch(/fatherOrSpouseNameSetter\.call\([^,]+,\s*"([^"]+)"\)/),
      dob: getMatch(/dobSetter\.call\([^,]+,\s*"([^"]+)"\)/),
      mobile: getMatch(/mobileNoSetter\.call\([^,]+,\s*"([^"]+)"\)/),
      email: getMatch(/emailSetter\.call\([^,]+,\s*"([^"]+)"\)/),
      profession: getMatch(/professionSetter\.call\([^,]+,\s*"([^"]+)"\)/),
      country: getMatch(/countrySetter\.call\([^,]+,\s*"([^"]+)"\)/),
      state: getMatch(/stateSetter\.call\([^,]+,\s*"([^"]+)"\)/),
      district: getMatch(/districtSetter\.call\([^,]+,\s*"([^"]+)"\)/),
      city: getMatch(/citySetter\.call\([^,]+,\s*"([^"]+)"\)/),
      street: getMatch(/streetSetter\.call\([^,]+,\s*"([^"]+)"\)/),
      doorNo: getMatch(/doorNoSetter\.call\([^,]+,\s*"([^"]+)"\)/),
      pincode: getMatch(/pincodeSetter\.call\([^,]+,\s*"([^"]+)"\)/),
      nearestTtdTemple: getMatch(/nearestTtdTempleInputSetter\.call\([^,]+,\s*"([^"]+)"\)/),
    };
  };


  const handleFileUpload = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const reader = new FileReader();
    reader.onload = (event) => {
      try {
        const encryptedContent = event.target.result;
        const bytes = CryptoJS.AES.decrypt(encryptedContent, secretKey);
        const decryptedText = bytes.toString(CryptoJS.enc.Utf8);

        if (!decryptedText) {
          alert("❌ Decryption failed. Check your secret key.");
          return;
        }

        const blocks = decryptedText
          .split(/setTimeout\(\s*\(\)\s*=>\s*{/g)
          .filter(Boolean)
          .map((block) => `setTimeout(() => {${block.trim()}`);
        setCodeBlocks(blocks);
        setCompletedIndexes([]);
        setPendingIndexes([]);
        setCopiedIndex(null);
      } catch (err) {
        alert("❌ Error reading or decrypting file.");
        console.error(err);
      }
    };

    reader.readAsText(file);
  };

  const handleCopy = (index) => {
    navigator.clipboard.writeText(codeBlocks[index]).then(() => {
      setCopiedIndex(index);
      setTimeout(() => setCopiedIndex(null), 2000);
      alert(`✅ Code for member ${index + 1} copied!`);
    });
  };

  const handleComplete = (index) => {
    setCompletedIndexes((prev) => [...prev, index]);
    setPendingIndexes((prev) => prev.filter((i) => i !== index));
  };

  const handlePending = (index) => {
    if (!pendingIndexes.includes(index)) {
      setPendingIndexes((prev) => [...prev, index]);
    }
  };

  const handleRowClick = (member) => {
    setSelectedMember(member);
    setShowModal(true);
  };

  const getRows = () => {
    const active = [];
    const pending = [];
    const completed = [];

    codeBlocks.forEach((block, index) => {
      const data = {
        serial: index + 1,
        index,
        block,
        ...extractMemberDetails(block),
      };

      if (completedIndexes.includes(index)) {
        completed.push(data);
      } else if (pendingIndexes.includes(index)) {
        pending.push(data);
      } else {
        active.push(data);
      }
    });

    return { active, pending, completed };
  };

  const { active, pending, completed } = getRows();

  return (
    <div className="container mt-4">
      <div className="text-center mb-3">
        <h3>Upload Encrypted Text File</h3>
        <input type="file" accept=".txt" onChange={handleFileUpload} />
      </div>

      {codeBlocks.length > 0 && (
        <div>
          <h5>Total Members: {codeBlocks.length}</h5>

          <table className="table table-bordered mt-3">
            <thead className="table-light">
              <tr>
                <th>S.No</th>
                <th>Name</th>
                <th>Station</th>
                <th>Copy</th>
                <th>Status</th>
              </tr>
            </thead>
            <tbody>
              {[...active, ...pending, ...completed].map((row) => {
                const isCompleted = completedIndexes.includes(row.index);
                const isPending = pendingIndexes.includes(row.index);
                const isCopied = copiedIndex === row.index;

                return (
                  <tr
                    key={row.index}
                    onClick={() => handleRowClick(row)}
                    style={{
                      cursor: "pointer",
                      backgroundColor: isCopied ? "#d1e7dd" : undefined,
                      color: isPending && !isCompleted ? "red" : undefined,
                      opacity: isCompleted ? 0.5 : 1,
                      textDecoration: isCompleted ? "line-through" : "none",
                    }}
                  >
                    <td>{row.serial}</td>
                    <td>{row.name}</td>
                    <td>{row.station}</td>
                    <td>
                      <button
                        className="btn btn-sm btn-success"
                        onClick={(e) => {
                          e.stopPropagation();
                          handleCopy(row.index);
                        }}
                        disabled={isCompleted}
                      >
                        📋 Copy
                      </button>
                    </td>
                    <td>
                      {!isCompleted && (
                        <>
                          <button
                            className="btn btn-sm btn-warning me-2"
                            onClick={(e) => {
                              e.stopPropagation();
                              handleComplete(row.index);
                            }}
                          >
                            ✅ Complete
                          </button>
                          <button
                            className="btn btn-sm btn-danger"
                            onClick={(e) => {
                              e.stopPropagation();
                              handlePending(row.index);
                            }}
                          >
                            ⏳ Pending
                          </button>
                        </>
                      )}
                      {isCompleted && (
                        <button className="btn btn-sm btn-secondary" disabled>
                          ✅ Completed
                        </button>
                      )}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      )}

      {/* Modal */}
      {showModal && selectedMember && (
        <div
          className="modal show fade d-block"
          tabIndex="-1"
          role="dialog"
          style={{ backgroundColor: "rgba(0, 0, 0, 0.5)" }}
        >
          <div className="modal-dialog modal-lg" role="document">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Member Details - #{selectedMember.serial}</h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={() => setShowModal(false)}
                ></button>
              </div>
              <div className="modal-body">
                <p><strong>Name:</strong> {selectedMember.name}</p>

                <p><strong>SurName:</strong> {selectedMember.surname}</p>
                <p><strong>Father/Spouse::</strong> {selectedMember.fatherSpouce}</p>
                <p><strong>DOB:</strong> {selectedMember.dob}</p>
                <p><strong>Mobile:</strong> {selectedMember.mobile}</p>
                 <p><strong>Email:</strong> {selectedMember.email}</p>
                <p><strong>Profession:</strong> {selectedMember.profession}</p>
                <p><strong>Address:</strong>{selectedMember.doorNo},{selectedMember.street}, 
                {selectedMember.district},{selectedMember.state}, {selectedMember.country}, {selectedMember.pincode}</p>
                <p><strong>Nearest TTD Temple:</strong> {selectedMember.nearestTtdTemple}</p>




              </div>


              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={() => setShowModal(false)}
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default CodePaginator;
